import * as React from 'react';

import { ModuleLayout } from '~/shared/layouts/ModuleLayout';
import { NavItem } from '~/shared/routing/createModuleNav';

export type AdminLayoutProps = {
  children: React.ReactNode;
  moduleNavigation?: NavItem;
};

export const AdminLayout = ({
  children,
  moduleNavigation,
}: AdminLayoutProps) => (
  <ModuleLayout
    noContentPadding={true}
    moduleNavigation={moduleNavigation}
    className="@AdminLayout"
  >
    {children}
  </ModuleLayout>
);
